import React from 'react';
// 1. Importe TODOS os ícones que você usa no site
import { 
  FaTv, FaSnowflake, FaFan, FaWineBottle, FaBath, FaBed, FaWifi, 
  FaMusic, FaUtensils, FaStar, FaGlassCheers, FaMask, FaCross, FaTree, FaShower, FaMugHot, FaCar 
} from 'react-icons/fa';

// 2. Adicione os novos ícones ao mapa
const iconMap = {
  // Ícones dos quartos
  FaTv: <FaTv />,
  FaSnowflake: <FaSnowflake />,
  FaFan: <FaFan />,
  FaWineBottle: <FaWineBottle />,
  FaBath: <FaBath />,
  FaBed: <FaBed />,
  FaWifi: <FaWifi />,
  FaShower: <FaShower />,
  FaMugHot: <FaMugHot />, 
  FaCar: <FaCar />, 
  // Ícones dos eventos (NOVOS)
  FaMusic: <FaMusic />,
  FaUtensils: <FaUtensils/>,
  FaStar: <FaStar />,
  FaGlassCheers: <FaGlassCheers />,
  FaMask: <FaMask />,
  FaCross: <FaCross />,
  FaTree: <FaTree />,
  
};

const FeatureIcon = ({ iconName, className }) => {
  const IconComponent = iconMap[iconName];
  // Adiciona a possibilidade de passar uma classe para o ícone, se necessário
  return IconComponent ? React.cloneElement(IconComponent, { className }) : null;
};

export default FeatureIcon;